import {HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {LoaderService} from "../app/services/loader.service";
import {finalize} from "rxjs";

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  constructor(private loaderService: LoaderService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (!req.url.includes('/api/smart-summary-last-calls') && !req.url.includes('/api/epa/status')) {
      this.loaderService.addLoading();
    }

    return next.handle(req).pipe(
      finalize(() => this.loaderService.stopLoading())
    );
  }

}
